/**
 * Floating XP popup (e.g. "+12 ⚡") that fades out and rises.
 * Mounts to body and self-removes after 1.2s.
 */
export function showXpPopup(text: string, color: string): void {
  const el = document.createElement('div');
  el.className = 'xp-popup';
  el.textContent = text;
  el.style.color = color;
  document.body.appendChild(el);
  // CSS animation handles transform + opacity; remove on animationend
  el.addEventListener('animationend', () => el.remove());
}

/**
 * Flash the quiz card green or red briefly.
 */
export function flashCard(card: HTMLElement, kind: 'correct' | 'wrong'): void {
  card.classList.remove('flash-correct', 'flash-wrong');
  // Force reflow so class re-add re-triggers animation
  void card.offsetWidth;
  card.classList.add(kind === 'correct' ? 'flash-correct' : 'flash-wrong');
}
